'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t from "../defs/DotsSixVertical.js";
var s = Object.defineProperty, c = Object.defineProperties;
var f = Object.getOwnPropertyDescriptors;
var r = Object.getOwnPropertySymbols;
var p = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
var a = (e, t2, o) => t2 in e ? s(e, t2, { enumerable: true, configurable: true, writable: true, value: o }) : e[t2] = o, i = (e, t2) => {
  for (var o in t2 || (t2 = {}))
    p.call(t2, o) && a(e, o, t2[o]);
  if (r)
    for (var o of r(t2))
      l.call(t2, o) && a(e, o, t2[o]);
  return e;
}, m = (e, t2) => c(e, f(t2));
const D = forwardRef((e, t$1) => /* @__PURE__ */ a__default.createElement(b, m(i({ ref: t$1 }, e), { weights: t })));
D.displayName = "DotsSixVertical";
export {
  D as DotsSixVertical
};
